import React, { useRef, useState } from 'react';
import { Tooltip } from 'reactstrap';
import Badge from '../../components/badge';

const OverflowText = ({ text, badge = false }) => {
  const target = useRef(null);
  const content = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const Component = badge ? Badge : 'span';

  return (
    <>
      <Component
        ref={target}
        className="target-site-overflow"
        onMouseEnter={() => setIsOpen(content.current.scrollWidth > content.current.clientWidth)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <span ref={content} className="target-site-overflow-text">{text}</span>
      </Component>
      {isOpen && (
        <Tooltip target={() => target.current} isOpen placement="top" trigger="manual"
          fade={false} className="target-site-tooltip">
          {text}
        </Tooltip>
      )}
    </>
  );
};

export default OverflowText;
